import { createFileRoute } from "@tanstack/react-router";
import { RequireSignedIn } from "@/components/auth/RequireSignedIn";
import { AppLoader } from "@/components/loading/AppLoader";
import { AccountNux } from "@/features/account-nux";

/**
 * TanStack file-route contract for the stable `/account_nux` path. The route
 * waits for application loading, requires an authenticated session, and then
 * renders AccountNux; that flow owns eligibility and fallback redirects.
 */
export const Route = createFileRoute("/account_nux")({
  component: AccountNuxRoute,
});

function AccountNuxRoute() {
  return (
    <AppLoader>
      <RequireSignedIn>
        <AccountNux />
      </RequireSignedIn>
    </AppLoader>
  );
}
